export default "__VITE_ASSET__CTmtxMb7__"